module.exports = __webpack_public_path__ + "static/media/headerLogo.e86c0ee4.png";